import { LuPin, LuPinOff } from "react-icons/lu";
import {
  SideMenuBehavior,
  useSideMenuActions,
  useSideMenuBehavior,
} from "../../../view_stores/useSideMenuStore";

export default function SideMenuPinBtn() {
  const sideMenuBehavior = useSideMenuBehavior();
  const { switchBehavior } = useSideMenuActions();

  return (
    <div className="w-full flex justify-end">
      <button
        onClick={switchBehavior}
        className="py-2.5 pl-3.5 pr-2.5 rounded-s-full
          text-light-text-muted dark:text-dark-text-muted
        bg-light-surface-secondary dark:bg-dark-surface-secondary
        hover:text-light-text dark:hover:text-dark-text hover:bg-light-hover dark:hover:bg-dark-hover
        transition-colors duration-200"
      >
        {sideMenuBehavior === SideMenuBehavior.PINNED ? (
          <LuPinOff size={20} className="rotate-[30deg]" />
        ) : (
          <LuPin size={20} className="rotate-[30deg]" />
        )}
      </button>
    </div>
  );
}
